const styles = theme => ({
  table: {
    tableLayout: 'fixed'
  },
  tableTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
  },
  tableHead: {
    backgroundColor: 'rgb(249, 249, 249)',

    '& tr td.new-design-cell': {
      '&:not(:nth-of-type(7)):not(:nth-of-type(8)):not(:nth-of-type(9))': {
        paddingTop: 8,
      }
    }
  },
  tableCell: {
    fontFamily: 'Roboto-Regular',
    fontSize: 14,
    color: '#202A38',
    padding: '8px 5px',
    '&:not(.new-design-cell)': {
      verticalAlign: 'middle',
    },
    '&.new-design-cell': {
      '&:not(:nth-of-type(7)):not(:nth-of-type(8)):not(:nth-of-type(9))': {
        paddingTop: 13,
      }
    },
    '&:nth-of-type(1)': {
      width: 50,
      textAlign: 'center',
    },
    '&:nth-of-type(2)': {
      width: 390,
    },
    '&:nth-of-type(3)': {
      width: 78,
    },
    '&:nth-of-type(4)': {
      width: 50,
    },
    '&:last-child': {
      width: 45,
    },

    '& .ellipsis': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    '& .name': {
      cursor: 'pointer',
      '&:hover': {
        textOverflow: 'initial',
        overflow: 'initial',
        whiteSpace: 'initial',
        wordBreak: 'break-all'
      }
    },
    '& .link': {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      cursor: 'pointer',
    },
    '& .bold': {
      fontFamily: 'Roboto-Bold',
      fontWeight: 'normal,'
    },
  },
  tableFooter: {
    background: 'inherit',

    '& .MuiTableCell-root': {
      verticalAlign: 'middle',

      '&:nth-of-type(1)': {
        textAlign: 'left'
      },

      '&.new-design-footer-cell': {
        background: '#EEF0F2'
      }
    }
  },

  [theme.breakpoints.down('md')]: {
    tableCell: {
      '&:nth-of-type(2)': {
        width: 250,
      },
    }
  },

  [theme.breakpoints.down('sm')]: {
    tableCell: {
      padding: 5,
      fontSize: 12,
      '&:nth-of-type(2)': {
        width: 200,
      },
    }
  },


  [theme.breakpoints.only('xs')]: {
    tableCell: {
      '& .hide-xs': {
        display: 'none'
      },
      '& .show-xs': {
        display: 'initial'
      }
    }
  }
});

export default styles;